import { multiSelectorOptionsMapper, optionsMapper } from '../utils';

const options = [
  'Limpeza simples',
  'Limpeza pesada',
  'Inspeção visual',
  'Troca de palete',
  'Strechamento de palete',
].map(o => {
  return { label: o, value: o }
});

export const useBlockedProductTaskTypeOptions = () => {
  return {
    singleSelectOptions: options.map(optionsMapper),
    multiSelectOptions: options.map(multiSelectorOptionsMapper),
  }
}

